import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { handleAd } from '@ifeng/ui_pc_ad';

class Meeting extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        ad: PropTypes.object,
    };

    ref = React.createRef();

    async componentDidMount() {
        const { ad } = this.props;

        const callbackFn = await handleAd(ad);

        callbackFn(this.ref.current, ad.data);
    }

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const pic = content[0];
        const list = content.slice(1, 7);

        return (
            <div>
                <div className={styles.pic_box}>
                    <a href={pic.url} target="_blank" title={pic.title} className={styles.pic}>
                        <img src={pic.banner} width="300" height="169" alt={pic.title} className={styles.trans} />
                    </a>
                    <div className={styles.mask} />
                    <h3 className={styles.title}>
                        <a href={pic.url} target="_blank">
                            {pic.title}
                        </a>
                    </h3>
                    <div className={styles.tip}>专题</div>
                </div>
                <ul className={styles.list} ref={this.ref}>
                    {list.map((item, index) => (
                        <li key={index}>
                            <a href={item.url} target="_blank" title={item.title}>
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(Meeting);
